import DateRangePicker from './dateRangePicker';

export * from './dateRangePicker';

export default DateRangePicker;
